module.exports = __webpack_public_path__ + "static/media/green-small-arrow.a8ba673a.svg";